<div class="astral-stack-l" [formGroup]="form">
  <section class="astral-section-surface">
    <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
      <astral-select [control]="form.controls.homeqRequirementProfile" [itemsSource]="homeqOptions.requirementProfiles"></astral-select>
      <astral-checkbox [control]="form.controls.homeqIsNewProduction"></astral-checkbox>
      <astral-date-picker [emptyIsNull]="true" [control]="form.controls.vacancyFrom"></astral-date-picker>
      <astral-date-picker [emptyIsNull]="true" [control]="form.controls.vacancyTo"></astral-date-picker>
      <astral-date-picker [emptyIsNull]="true" [control]="form.controls.publishFrom"></astral-date-picker>
      <astral-date-picker [emptyIsNull]="true" [control]="form.controls.publishTo"></astral-date-picker>
      <app-money-box [control]="form.controls.monthlyRent"></app-money-box>
      <app-money-box [control]="form.controls.yearlyRent"></app-money-box>
      <astral-select
        [control]="form.controls.monthsWithRent"
        [itemsSource]="monthSelection"
        [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.CHARGED_MONTHS'"
        [multiple]="true"
      ></astral-select>
      <app-text-box-readonly
        [caption]="'PROPERTY.HOMEQ_OFFICE'"
        [text]="officeName === '' ? ('CONST.NONE' | translate) : officeName"
        [helpText]="'PROPERTY.HELP_TEXT.HOMEQ_OFFICE'"
      ></app-text-box-readonly>
    </astral-layout-group>
  </section>

  <section class="astral-section-surface astral-form-stack">
    <astral-textarea [control]="form.controls.homeQObjectDescription"></astral-textarea>
    <astral-checkbox [control]="form.controls.uniqueObjectDescription"></astral-checkbox>
  </section>

  <section class="astral-section-surface astral-form-stack">
    <astral-textarea [control]="form.controls.buildingDescription"></astral-textarea>
    <astral-checkbox [control]="form.controls.uniqueBuildingDescription"></astral-checkbox>
  </section>

  <section class="astral-section-surface astral-form-stack">
    <astral-textarea [control]="form.controls.buildingAreaDescription"></astral-textarea>
    <astral-checkbox [control]="form.controls.uniqueBuildingAreaDescription"></astral-checkbox>
  </section>
</div>
